import http from '../common/api';
import {ApiSettings} from "application";

const cancelRequest = async (reportId) => {
  return await http.get(ApiSettings.cancelRequest(reportId));
}

export default cancelRequest;
